import { stringifyUrl } from "query-string";
import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function PlayerRequestFormatter(message) {
    let body;
    const { baseUrl, endpoint, method, headers, params } = getRequestProps(ConnectionNames.player, message);
    /**
     * NOTE: Player API supports other than "GET" requests but they are not
     * going to be implemented here in the next version. I'm commenting the
     * below part to to don't drop the test coverage.
     */
    let queryStringParams = {};
    if (params) {
        if (method !== "GET") {
            headers["Content-Type"] = "application/json; charset=utf-8";
            body = JSON.stringify(params);
        }
        else {
            queryStringParams = params;
        }
    }
    const query = stringifyUrl({
        url: `${baseUrl}${endpoint}`,
        query: queryStringParams
    }, {
        skipNull: true,
        sort: false
    });
    return new Request(query, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=PlayerRequestFormatter.js.map